import { useEffect } from 'react'
import { WebCompass } from '@/assets/icons'
import { Card } from '@/components/card/Card'
import { Userpilot } from 'userpilot'

function triggerSampleMatterChecklist() {
  Userpilot.trigger('checklist:igMwn3XITo')
}

export function SampleMatterChecklistCard() {
  useEffect(() => {
    triggerSampleMatterChecklist()
  }, [])

  return (
    <div className="mt-6">
      <Card
        actionIcon="arrow-up-right"
        description="Walk through case timeline, legal research, and demand drafting on preloaded case files"
        leadingElement={
          <span className="flex items-center justify-center rounded-md bg-green-100 p-2 text-green-800 transition-colors hover-capable:group-hover:bg-green-200">
            <WebCompass className="size-6" aria-hidden="true" />
          </span>
        }
        onClick={triggerSampleMatterChecklist}
        title="Explore key litigation features"
      />
    </div>
  )
}
